"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosTVDisplayUpdateInputSchema = exports.APosTVDisplayCreateInputSchema = exports.APosTVDisplaySchema = exports.APosTVDisplayStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosTVDisplayStatusSchema = zod_1.z.enum(['active', 'inactive', 'offline']);
exports.APosTVDisplaySchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    displayId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    deviceCode: zod_1.z.string().optional(),
    resolution: zod_1.z.enum(['1080p', '4k']).default('1080p'),
    orientation: zod_1.z.enum(['landscape', 'portrait']).default('landscape'),
    activePlaylistId: id_schema_1.EntityIdSchema.optional(),
    activeAdvertisementIds: zod_1.z.array(zod_1.z.string()).default([]),
    refreshIntervalSeconds: zod_1.z.number().int().positive().default(30),
    status: exports.APosTVDisplayStatusSchema.default('inactive'),
    lastHeartbeat: zod_1.z.number().optional(),
    ipAddress: zod_1.z.string().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosTVDisplayCreateInputSchema = zod_1.z.object({
    locationId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    resolution: zod_1.z.enum(['1080p', '4k']).optional(),
    orientation: zod_1.z.enum(['landscape', 'portrait']).optional(),
    refreshIntervalSeconds: zod_1.z.number().int().positive().optional(),
});
exports.APosTVDisplayUpdateInputSchema = exports.APosTVDisplayCreateInputSchema.partial().extend({
    activePlaylistId: id_schema_1.EntityIdSchema.optional(),
    activeAdvertisementIds: zod_1.z.array(zod_1.z.string()).optional(),
    status: exports.APosTVDisplayStatusSchema.optional(),
});
//# sourceMappingURL=tv-display.schema.js.map